const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.app.visitedViews,
  account: state => state.user.account,
  subAccount: state => state.user.subAccount,
  payment: state => state.user.payment,
  uid: state => state.user.uid,
  email: state => state.user.email,
  introduction: state => state.user.introduction,
  auth_type: state => state.user.auth_type,
  status: state => state.user.status,
  roles: state => state.user.roles,
  merchantAgent: state => state.user.merchantAgent,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  siderbar_routers:state => state.permission.siderbar_routers,
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js